import { TooltipCode } from './codeHighlights/TooltipCode';

export const ToolTip = () => {
  return (
    <>
      <button
        type="button"
        className="btn btn-secondary"
        data-bs-toggle="tooltip"
        data-bs-placement="left"
        title="Tooltip on top"
      >
        Tooltip on top
      </button>

      <button
        type="button"
        className="btn btn-secondary"
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title="Tooltip on right"
      >
        Tooltip on right
      </button>

      <button
        type="button"
        className="btn btn-secondary"
        data-bs-toggle="tooltip"
        data-bs-placement="bottom"
        title="Tooltip on bottom"
      >
        Tooltip on bottom
      </button>
      <button
        type="button"
        className="btn btn-secondary"
        data-bs-toggle="tooltip"
        data-bs-placement="right"
        title="Tooltip on left"
      >
        Tooltip on left
      </button>

      <div className="mt-5">
        <h2>Tooltip HTML-Code Example</h2>
        <TooltipCode />
      </div>
    </>
  );
};
